import { firmClientKeys } from '../FirmClient';

export const insuranceKeys = {
  insurancePolicies: (householdID: string | undefined | null) => [
    'insurancePolicies',
    ...firmClientKeys.household(householdID),
  ],
  insurancePolicy: (id: string) => ['insurancePolicies', id],
};
